import { Frame, SportPlay } from "../../types";
import { getActionStencils } from "../../utils";

export const getFrameMaxEndTime = (frame: Frame): number =>
  Math.max(...getActionStencils(frame.frameStencils).map((stencil) => stencil.endTime), 0);

export const getTotalPlayDuration = (play: SportPlay): number =>
  play.frames.reduce((acc, frame) => acc + getFrameMaxEndTime(frame), 0);
